var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 139,
    viewBox: "0 0 421 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.11 46.9005L374.298 46.9005L374.298 0.15514L421.11 0.155144L421.11 46.9005Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.298 46.9005L327.486 46.9005L327.486 0.15514L374.298 0.155144L374.298 46.9005Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.028 0.154911L187.216 0.154907L187.216 -46.5905L234.028 -46.5905L234.028 0.154911Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M421.11 0.154911L374.298 0.154907L374.298 -46.5905L421.11 -46.5905L421.11 0.154911Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7579 46.9005L46.9457 46.9005L46.9457 0.15514L93.7579 0.155144L93.7579 46.9005Z",
    fill: "#D62340"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327.486 46.9005L280.673 46.9005L280.673 0.15514L327.486 0.155144L327.486 46.9005Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M374.298 0.154911L327.486 0.154907L327.486 -46.5905L374.298 -46.5905L374.298 0.154911Z",
    fill: "#D62340"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.29974 46.9005L-46.5125 46.9005L-46.5124 0.15514L0.299744 0.155144L0.29974 46.9005Z",
    fill: "#2E2E2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.028 46.9005L187.216 46.9005L187.216 0.15514L234.028 0.155144L234.028 46.9005Z",
    fill: "#D62340"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.382 46.9005L140.57 46.9005L140.57 0.15514L187.382 0.155144L187.382 46.9005Z",
    fill: "#2E2E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1123 46.9005L0.300064 46.9005L0.300068 0.15514L47.1123 0.155144L47.1123 46.9005Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.57 46.9005L93.7579 46.9005L93.7579 0.15514L140.57 0.155144L140.57 46.9005Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.84 46.9005L234.028 46.9005L234.028 0.15514L280.84 0.155144L280.84 46.9005Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.84 0.1554L234.028 0.155396L234.028 -46.59L280.84 -46.59L280.84 0.1554Z",
    fill: "#2E2E2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.175507 35.1869L-11.4864 46.8322L-23.1483 35.1869L-11.4864 23.5417L0.175507 35.1869Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.213318 11.8817L-11.4486 23.527L-23.1104 11.8817L-11.4486 0.236508L0.213318 11.8817Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2843 46.9005L46.9457 35.2558L46.9457 46.9005L35.2843 46.9005Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.623 46.9005L11.9616 46.9005L46.9458 11.9663L46.9458 23.611L23.623 46.9005Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300064 46.9005L46.9457 0.155142L35.2843 0.155141L0.300065 35.2558L0.300064 46.9005Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300186 23.611L23.623 0.155103L11.9616 0.155102L0.300187 11.9662L0.300186 23.611Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.57 11.9659L128.742 0.154836L140.57 0.154837L140.57 11.9659Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M140.57 23.611L140.57 35.2557L105.419 0.155128L117.081 0.155129L140.57 23.611Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.57 46.9005L93.7579 0.155138L93.7579 11.9662L128.742 46.9005L140.57 46.9005Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.081 46.9005L93.7579 23.611L93.7579 35.2558L105.419 46.9005L117.081 46.9005Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.028 23.611L234.028 0.321459L210.705 0.321457C210.538 13.1307 221.034 23.611 234.028 23.611Z",
    fill: "#2E2E2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M257.351 0.155103L234.028 0.155101L234.028 23.611C246.855 23.611 257.351 13.1307 257.351 0.155103Z",
    fill: "#D62340"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M234.028 -23.1341L234.028 0.155396L257.351 0.155398C257.351 -12.6538 246.855 -23.1341 234.028 -23.1341Z",
    fill: "#2E2E2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M210.538 0.154907L233.861 0.154909L233.861 -23.1346C221.034 -23.1346 210.538 -12.6543 210.538 0.154907Z",
    fill: "#D62340"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M315.824 35.2557L292.501 35.2557L292.501 11.9662L315.824 11.9662L315.824 35.2557Z",
    fill: "#2E2E2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M362.47 35.2557L339.147 35.2557L339.147 11.9662L362.47 11.9662L362.47 35.2557Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M327.486 -23.1346L350.808 0.154909L374.298 -23.1346L327.486 -23.1346Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M420.981 23.603L397.657 46.8934L374.333 23.603L397.657 0.312506L420.981 23.603Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M409.201 23.6029L397.539 35.2482L385.877 23.6029L397.539 11.9577L409.201 23.6029Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.299999 0.337048L0.300003 -46.4083L47.1122 -46.4083L47.1122 0.337052L0.299999 0.337048Z",
    fill: "#D62340"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0513 0.231808L47.0513 -46.5135L93.8635 -46.5135L93.8635 0.231812L47.0513 0.231808Z",
    fill: "#2E2E2E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8029 0.292374L93.8029 -46.453L140.615 -46.453L140.615 0.292378L93.8029 0.292374Z",
    fill: "#2E2E2E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9454 0.154907L46.9454 -46.5905L93.7576 -46.5905C93.7576 -20.6393 72.767 0.154909 46.9454 0.154907Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6251 0.164129L0.301331 -23.1263L23.6251 -46.4168L46.9488 -23.1263L23.6251 0.164129Z",
    fill: "#FAFAFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7575 -46.4241L117.08 -23.1346L93.7575 0.154907L93.7575 -46.4241Z",
    fill: "#FAFAFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M327.977 46.1546L327.977 92.9L281.165 92.9L281.165 46.1546L327.977 46.1546Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M281.226 46.0487L281.226 92.7941L234.415 92.7941L234.415 46.0487L281.226 46.0487Z",
    fill: "#FAFAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M234.475 46.1098L234.475 92.8551L187.664 92.8551L187.664 46.1097L234.475 46.1098Z",
    fill: "#2E2E2E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M246.199 46.2147L234.538 57.8595L234.538 46.2147L246.199 46.2147Z",
    fill: "#D62340"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M257.86 46.2148L269.522 46.2148L234.538 81.149L234.538 69.5043L257.86 46.2148Z",
    fill: "#D62340"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M281.183 46.2151L234.538 92.7941L246.199 92.7941L281.183 57.8598L281.183 46.2151Z",
    fill: "#D62340"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M281.183 69.5046L257.86 92.7941L269.522 92.7941L281.183 81.1493L281.183 69.5046Z",
    fill: "#D62340"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M304.625 46.1516L327.948 69.442L304.625 92.7325L281.302 69.442L304.625 46.1516Z",
    fill: "#2E2E2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M187.727 92.7931L211.049 69.5036L187.727 46.2141L187.727 92.7931Z",
    fill: "#FAFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.6674 92.9003L-46.6674 46.1549L0.14418 46.1549L0.144176 92.9003L-46.6674 92.9003Z",
    fill: "#D62340"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0834462 92.795L0.0834503 46.0497L46.895 46.0497L46.895 92.795L0.0834462 92.795Z",
    fill: "#2E2E2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8344 92.8556L46.8344 46.1102L93.6459 46.1102L93.6459 92.8556L46.8344 92.8556Z",
    fill: "#2E2E2E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0225372 92.7181L-0.0225331 45.9728L46.789 45.9728C46.789 71.9239 25.7988 92.7181 -0.0225372 92.7181Z",
    fill: "#FAFAFA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0224152 81.0736L-0.0224121 46.1394L34.9613 46.1394C35.1279 65.4364 19.4685 81.0736 -0.0224152 81.0736Z",
    fill: "#2E2E2E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M46.789 46.1391L70.1115 69.4286L46.789 92.7181L46.789 46.1391Z",
    fill: "#FAFAFA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M140.281 92.9003L140.281 46.1549L187.093 46.1549L187.093 92.9003L140.281 92.9003Z",
    fill: "#D62340"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5307 92.8395L93.5307 46.0941L140.342 46.0941L140.342 92.8395L93.5307 92.8395Z",
    fill: "#2E2E2E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M116.898 57.7233C123.339 57.7233 128.559 62.9369 128.559 69.3681C128.559 75.7993 123.339 81.0128 116.898 81.0128C110.458 81.0128 105.237 75.7993 105.237 69.3681C105.237 62.9368 110.458 57.7233 116.898 57.7233Z",
    fill: "#FAFAFA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M163.71 81.1793C170.207 81.1793 175.371 76.0224 175.371 69.5346C175.371 63.0468 170.207 57.8898 163.71 57.8898C157.213 57.8898 152.049 63.0468 152.049 69.5346C152.049 75.856 157.213 81.1793 163.71 81.1793Z",
    fill: "#FAFAFA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6444 92.1545L94.6444 138.9L47.8329 138.9L47.8329 92.1545L94.6444 92.1545Z",
    fill: "#FAFAFA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8936 92.0486L47.8936 138.794L1.08207 138.794L1.08208 92.0486L47.8936 92.0486Z",
    fill: "#FAFAFA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1427 92.1096L1.1427 138.855L-45.6688 138.855L-45.6688 92.1096L1.1427 92.1096Z",
    fill: "#2E2E2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8664 92.2146L1.20518 103.859L1.20519 92.2146L12.8664 92.2146Z",
    fill: "#D62340"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5277 92.2147L36.1889 92.2147L1.2052 127.149L1.2052 115.504L24.5277 92.2147Z",
    fill: "#D62340"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8501 92.2149L1.2052 138.794L12.8664 138.794L47.8501 103.86L47.8501 92.2149Z",
    fill: "#D62340"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8502 115.504L24.5277 138.794L36.189 138.794L47.8502 127.149L47.8502 115.504Z",
    fill: "#D62340"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2924 92.1514L94.6158 115.442L71.2923 138.732L47.9689 115.442L71.2924 92.1514Z",
    fill: "#2E2E2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.8fcf88d4efff116aa624d57ab7c63f9c.svg";
export { ForwardRef as ReactComponent };